
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding",
      function () {
        return require("private-next-pages/onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding"])
      });
    }
  